import { render, staticRenderFns } from "./UsersForm.vue?vue&type=template&id=04d93c22"
import script from "./UsersForm.vue?vue&type=script&lang=js"
export * from "./UsersForm.vue?vue&type=script&lang=js"
import style0 from "./UsersForm.vue?vue&type=style&index=0&id=04d93c22&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04d93c22')) {
      api.createRecord('04d93c22', component.options)
    } else {
      api.reload('04d93c22', component.options)
    }
    module.hot.accept("./UsersForm.vue?vue&type=template&id=04d93c22", function () {
      api.rerender('04d93c22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UsersForm.vue"
export default component.exports